import {
  Box,
  Typography,
  Container,
  TextField,
  Button,
  Grid,
  Link,
} from "@mui/material";
import { motion } from "framer-motion";
import { LinkedIn, GitHub, Phone } from "@mui/icons-material";
import { useRef } from "react";
import emailjs from "emailjs-com";

const Contact = () => {
  const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formRef.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      )
      .then(
        () => {
          alert("Message sent successfully!");
          formRef.current.reset();
        },
        (error) => {
          alert("Failed to send message, try again later.");
          console.error(error);
        },
      );
  };

  return (
    <Box id="contact" sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Typography variant="h4" gutterBottom align="center">
            Get In Touch
          </Typography>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <form ref={formRef} onSubmit={handleSubmit}>
                <TextField
                  fullWidth
                  name="form_name"
                  label="Name"
                  variant="outlined"
                  margin="normal"
                  required
                />
                <TextField
                  fullWidth
                  name="form_email"
                  label="Email"
                  variant="outlined"
                  margin="normal"
                  required
                  type="email"
                />
                <TextField
                  fullWidth
                  name="message" // You can keep this if your template has {{message}}
                  label="Message"
                  variant="outlined"
                  margin="normal"
                  required
                  multiline
                  rows={4}
                />
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2 }}
                >
                  Send Message
                </Button>
              </form>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Phone color="primary" sx={{ mr: 2 }} />
                <Typography>+88 01745803030</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <LinkedIn color="primary" sx={{ mr: 2 }} />
                <Typography>
                  <Link
                    href="https://www.linkedin.com/in/shimul47"
                    target="_blank"
                    rel="noopener"
                  >
                    Sohanur Rahman Shimul
                  </Link>
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <GitHub color="primary" sx={{ mr: 2 }} />
                <Typography>
                  <Link
                    href="https://github.com/shimul47"
                    target="_blank"
                    rel="noopener"
                  >
                    Shimul47
                  </Link>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Contact;
